// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Banner from "../feedback-indicators/Banner.res.js";
import * as Popover from "../overlays/Popover.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as DayPickerSingle from "./DayPickerSingle.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OverlayTriggerView from "../overlays/OverlayTriggerView.res.js";

function SelectDateFilter(props) {
  let onChange = props.onChange;
  let value = props.value;
  let __disabledFutureDays = props.disabledFutureDays;
  let information = props.information;
  let disabledFutureDays = __disabledFutureDays !== undefined ? __disabledFutureDays : false;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1 = Hover.use(popoverTriggerRef, undefined, undefined);
  let match$2 = React.useState(() => false);
  let setFocused = match$2[1];
  React.useEffect(() => {
    setFocused(param => popover.isOpen);
  }, [popover.isOpen]);
  let onChange$1 = value => {
    onChange(value);
    popover.close();
  };
  let isDayBlocked = day => {
    let day$1 = new Date(day.getTime());
    let now = new Date();
    day$1.setHours(0);
    day$1.setMinutes(0);
    now.setHours(0);
    now.setMinutes(0);
    if (disabledFutureDays) {
      return day$1.getTime() > now.getTime();
    } else {
      return false;
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx(OverlayTriggerView.make, {
          children: value !== undefined ? JsxRuntime.jsx(TextStyle.make, {
              children: I18n.dateTimeFormat(undefined, "long", undefined, undefined, undefined, undefined, undefined, undefined, undefined, value)
            }) : JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Select a date"),
              variation: "normal"
            }),
          preset: "filter",
          label: props.label,
          icon: "calendar",
          hovered: match$1[1],
          active: popover.isOpen,
          focused: match$2[0]
        }),
        ariaProps: popoverAriaProps.triggerProps,
        onPress: param => popover.toggle(),
        ref: popoverTriggerRef
      }),
      popover.isOpen ? JsxRuntime.jsx(Popover.make, {
          children: JsxRuntime.jsxs(Popover.Dialog.make, {
            children: [
              JsxRuntime.jsx(DayPickerSingle.make, {
                value: value,
                onChange: onChange$1,
                isDayBlocked: isDayBlocked
              }),
              information !== undefined ? JsxRuntime.jsx(Box.make, {
                  children: JsxRuntime.jsx(Banner.make, {
                    textStatus: {
                      TAG: "Info",
                      _0: information
                    }
                  }),
                  spaceX: "large",
                  spaceTop: "xsmall",
                  spaceBottom: "medium"
                }) : null
            ],
            ariaProps: popoverAriaProps.overlayProps,
            style: {
              maxWidth: "316px",
              minHeight: "300px"
            }
          }),
          triggerRef: popoverTriggerRef,
          state: {
            isOpen: popover.isOpen,
            close: popover.close,
            toggle: popover.toggle
          },
          placement: "bottom start",
          modal: false
        }) : null
    ]
  });
}

let make = React.memo(SelectDateFilter);

export {
  make,
}
/* make Not a pure module */
